import { useAuiState } from "@assistant-ui/react";

export const useIsLastConversationMessage = (): boolean =>
  useAuiState(s => s.message.index === s.thread.messages.length - 1);
